export enum StreakPrizeDayStatus {
  CREATED = 'CREATED',
  OPEN = 'OPENED',
  CLOSED = 'CLOSED'
}
